import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { ChallengeDetailsPage, ChallengesPage } from './pages'

const ChallengesRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.MOBILE_APP_ONLY.subMenuItems.CHALLENGES.link}
      permissions={[PERMISSIONS.METADATA_TREE.LIST]}
      component={ChallengesPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.CHALLENGE_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={ChallengeDetailsPage}
    />
  </Switch>
)

export default ChallengesRouter
